import React, { useState } from "react";
import Alert from "../../../controls/Alert";

const JetplanRouteValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  }); 

  let field = null;
  let error = false;
  let errorMessage = "";

  if (!error && record?.jetPlanRoute && record.jetPlanRoute !== null && record.jetPlanRoute !== "" && record.jetPlanRoute.length < 6) {
    error = true;
    errorMessage = "A route code must be at least 6 characters long";
  }

  if (!error && record?.jetPlanRoute && record.jetPlanRoute !== null && record.jetPlanRoute !== "" && record.jetPlanRoute.length >= 6 && record.jetPlanRoute.substring(0, 3) === "RT/") {
    error = true;
    errorMessage = "Do not prefix with RT/, this is done automatically";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {        
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default JetplanRouteValidator;